import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Typography } from "antd";
import React, { useEffect, useMemo } from "react";
import { BdPerson } from "../../../redux/actions/adminActions/newOrderRequestAction";
import { useDispatch, useSelector } from "react-redux";
import Alertify from "../../../services/alertify";

const { Title } = Typography;

const OrderDetailStep = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const transactionTypeOption = transactionTypeOptions.find(
          (option) => option.value === values.transaction_type
        );
        const locationOption = locationOptions.find(
          (option) => option.value === values.location_code
        );
        const branchCodeOption = branchCodeOptions.find(
          (option) => option.value === values.branch_code
        );
        const bdPersonOption = bd_person_options.find(
          (option) => option.value === values.bd_person
        );

        const extendedValues = {
          ...values,
          transaction_type_title: transactionTypeOption?.label || "",
          location_name: locationOption?.label || "",
          branch_code_name: branchCodeOption?.label || "",
          bd_person_name: bdPersonOption?.label || "",
        };

        console.log("Form Values:", extendedValues);
        props.onNext(extendedValues);
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };
  const handleDraft = () => {
    form
      .validateFields()
      .then((values) => {
        const transactionTypeOption = transactionTypeOptions.find(
          (option) => option.value === values.transaction_type
        );
        const locationOption = locationOptions.find(
          (option) => option.value === values.location_code
        );
        const branchCodeOption = branchCodeOptions.find(
          (option) => option.value === values.branch_code
        );
        const bdPersonOption = bd_person_options.find(
          (option) => option.value === values.bd_person
        );

        const extendedValues = {
          ...values,
          transaction_type_title: transactionTypeOption?.label || "",
          location_name: locationOption?.label || "",
          branch_code_name: branchCodeOption?.label || "",
          bd_person_name: bdPersonOption?.label || "",
        };

        console.log("Form Values:", extendedValues);
        props.onNext(extendedValues);
        window.history.back();
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };

  const handlePrevious = () => {
    const values = form.getFieldsValue();
    console.log("Form Values:", values);
    props.handlePrev(values);
  };

  const bdPersons = useSelector((state) => state.bd_person_store);
  const bd_person_options = useMemo(() => {
    return bdPersons.bd_person || [];
  }, [bdPersons]);

  useEffect(() => {
    dispatch(BdPerson())
      .then((response) => {
        // console.log("Bd Persons are:", response);
      })
      .catch((error) => {
        Alertify.error("Failed to fetch Bd Persons: " + error.message);
      });
  }, [dispatch]);

  useEffect(() => {
    form.setFieldsValue({
      location_code: props.formData.location_code,
      branch_code: props.formData.branch_code,
      project_segment: props.formData.project_segment,
      requestedDate: props.formData.requestedDate,
      transaction_type: props.formData.transaction_type,
      project_type: props.formData.project_type,
      // orderType: props.formData.orderType,
      bd_person: props.formData.bd_person,
      consultant_name: props.formData.consultant_name,
      opportunity_number: props.formData.opportunity_number,
      doc_number: props.formData.doc_number,
    });
  }, [form, props.formData]);

  useEffect(() => {
    if (bd_person_options.length > 0 && !props.formData.bd_person) {
      form.setFieldsValue({
        bd_person: `${bd_person_options[0].seller_code}`,
      });
    }
  }, [bd_person_options, form]);

  const today = new Date().toISOString().split("T")[0];

  // Define options for Select components
  const transactionTypeOptions = [{ label: "Pay Later", value: "cod" }];

  const locationOptions = [{ value: "FG-RDP", label: "Finished Good Store" }];

  const branchCodeOptions = [{ label: "AAIPL Rudrapur", value: "RDP" }];

  return (
    <div className="border rounded-lg p-4 w-full">
      <Form form={form} layout="vertical" className="text-left">
        <div className="border p-4 rounded-lg">
          <Title level={3} className="text-left py-4">
            Order Details
          </Title>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="Location Code"
                name="location_code"
                rules={[
                  {
                    required: true,
                    message: "Please select Location code",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select Location Code"
                  options={locationOptions}
                />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Branch Code"
                name="branch_code"
                rules={[
                  {
                    required: true,
                    message: "Please select Branch Code",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select Branch Code"
                  options={branchCodeOptions}
                />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="Project Segment"
                name="project_segment"
                rules={[
                  {
                    required: true,
                    message: "Please select Project Segment",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select Project Segment"
                  options={[
                    {
                      label: "Power Plant",
                      value: "Power Plant",
                    },
                    {
                      label: "Hospital",
                      value: "Hospital",
                    },
                    {
                      label: "Mall/Multiplex",
                      value: "Mall/ Multiplex",
                    },
                    {
                      label: "IT/ITES",
                      value: "IT/ITES",
                    },
                    {
                      label: "Office Building",
                      value: "Office Building",
                    },
                    {
                      label: "OEM",
                      value: "OEM",
                    },
                    {
                      label: "Institution",
                      value: "Institution",
                    },
                    {
                      label: "Defence",
                      value: "Defence",
                    },
                    {
                      label: "Hotel",
                      value: "Hotel",
                    },
                    {
                      label: "Refinery",
                      value: "Refinery",
                    },
                    {
                      label: "Dairy",
                      value: "Dairy",
                    },
                    {
                      label: "Metro",
                      value: "Metro",
                    },
                    {
                      label: "Airport",
                      value: "Airport",
                    },
                    {
                      label: "Railways",
                      value: "Railways",
                    },
                    {
                      label: "Pharma",
                      value: "Pharma",
                    },
                    {
                      label: "Process",
                      value: "Process",
                    },
                    {
                      label: "Factory",
                      value: "Factory",
                    },
                    {
                      label: "Cold Storage",
                      value: "Cold Storage",
                    },
                    {
                      label: "Warehouse",
                      value: "Warehouse",
                    },
                    {
                      label: "Eco sheet - Non Specified Projects",
                      value: "Eco sheet - Non Specified Projects",
                    },
                    {
                      label: "Eco Tube/tapes - Retail Market",
                      value: "Eco Tube/tapes - Retail Market",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Requested Delivery Date"
                name="requestedDate"
                rules={[
                  {
                    required: true,
                    message: "Please enter Requested Delivery Date",
                  },
                  {
                    validator: (_, value) =>
                      value && value < today
                        ? Promise.reject(
                            new Error("Requested date cannot be in the past")
                          )
                        : Promise.resolve(),
                  },
                ]}
              >
                <Input type="date" id="date" min={today} />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="Transaction Type"
                name="transaction_type"
                rules={[
                  {
                    required: true,
                    message: "Please select Transaction Type",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select "
                  options={transactionTypeOptions}
                />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item
                label="Project Type"
                name="project_type"
                rules={[
                  {
                    required: true,
                    message: "Please select Project Type",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select "
                  options={[
                    {
                      label: "Private",
                      value: "Private",
                    },
                    {
                      value: "Government",
                      label: "Government",
                    },
                  ]}
                />
              </Form.Item>
            </div>
          </div>

          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item
                label="External Document Number"
                name="doc_number"
                rules={[
                  {
                    required: true,
                    message: "Please enter External Document Number",
                  },
                ]}
              >
                <Input placeholder="External Document Number" maxLength={20} />
              </Form.Item>
            </div>

            <div className="w-full mx-2">
              <Form.Item
                label="BD Person"
                name="bd_person"
                rules={[
                  {
                    required: true,
                    message: "Please select BD Person",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select "
                  options={bd_person_options.map((items) => ({
                    value: `${items.seller_code}`,
                    label: `${items.seller_code}, ${items.name}`,
                  }))}
                />
              </Form.Item>
            </div>

            {/* <div className="w-full mx-2">
              <Form.Item
                label="Order Type"
                name="orderType"
                rules={[
                  {
                    required: true,
                    message: "Please select Order Type",
                  },
                ]}
              >
                <Select
                  className="text-left"
                  placeholder="Select "
                  options={[
                    {
                      label: "Normal Order",
                      value: "Normal Order",
                    },
                    {
                      label: "Blanket Order",
                      value: "Blanket Order",
                    },
                  ]}
                />
              </Form.Item>
            </div> */}
          </div>
          {console.log(bd_person_options)}
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="Consultant Name" name="consultant_name">
                <Input placeholder="Consultant Name" maxLength={20} />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="Opportunity Number" name="opportunity_number">
                <Input placeholder="Opportunity Number" maxLength={20} />
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center w-full mt-4">
          <Button
            className="text-md rounded-lg"
            onClick={handlePrevious}
            disabled={props.currentStep <= 0}
          >
            <LeftCircleOutlined className="mb-[-3px]" /> PREVIOUS
          </Button>
          <div>
            <Button
              className="text-md rounded-lg mr-4"
              type="primary"
              htmlType="submit"
              onClick={handleDraft}
            >
              SAVE DRAFT
            </Button>
            <Button
              className="text-md rounded-lg"
              type="primary"
              htmlType="submit"
              onClick={handleSubmit}
            >
              NEXT <RightCircleOutlined className="mb-[-3px]" />
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default OrderDetailStep;
